import logo from '../../img/MainCreateBlock/Upload_Logo.png';

export const pageInfo = {
   logo: logo,
}
